import * as React from "react";

function SvgIcUpcoming(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4a8 8 0 00-7.545 10.667v.002c.138.388.305.763.498 1.121a1 1 0 11-1.76.95 9.945 9.945 0 01-.624-1.407v-.002A9.986 9.986 0 012 12C2 6.477 6.477 2 12 2c2.251 0 4.33.745 6 2V3a1 1 0 112 0v3.343a1 1 0 01-1 1h-3.5a1 1 0 110-2h.938A7.961 7.961 0 0012 4zm9 7a1 1 0 011 1c0 .667-.065 1.319-.19 1.95a1 1 0 01-1.962-.388c.1-.504.152-1.026.152-1.562a1 1 0 011-1zm-.96 5.17a1 1 0 01.275 1.387 10.052 10.052 0 01-2.758 2.758 1 1 0 01-1.113-1.662 8.046 8.046 0 002.21-2.209 1 1 0 011.386-.274zm-15.02 1.6a1 1 0 011.414-.023 8.024 8.024 0 002.002 1.418 1 1 0 01-.892 1.79 10.025 10.025 0 01-2.501-1.772 1 1 0 01-.023-1.414zm9.717 2.865a1 1 0 01-.787 1.175 10.048 10.048 0 01-3.482.073 1 1 0 11.304-1.976 8.07 8.07 0 002.79-.06 1 1 0 011.175.788zM13 7a1 1 0 10-2 0v5a1 1 0 00.293.707l2 2a1 1 0 001.414-1.414L13 11.586V7z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcUpcoming;
